import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "English", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Français", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MDBIcon = _resolveComponent("MDBIcon")!
  const _component_MDBBtn = _resolveComponent("MDBBtn")!
  const _component_MDBDropdownToggle = _resolveComponent("MDBDropdownToggle")!
  const _component_MDBDropdownItem = _resolveComponent("MDBDropdownItem")!
  const _component_MDBDropdownMenu = _resolveComponent("MDBDropdownMenu")!
  const _component_MDBDropdown = _resolveComponent("MDBDropdown")!

  return (_openBlock(), _createBlock(_component_MDBDropdown, {
    btnGroup: "",
    modelValue: _ctx.dropdown,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dropdown) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_MDBBtn, {
        size: "2x",
        class: "bg-info",
        color: "bg-info",
        title: _ctx.language(_ctx.country)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MDBIcon, { flag: _ctx.country }, null, 8, ["flag"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_MDBDropdownToggle, {
        split: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropdown = !_ctx.dropdown))
      }),
      _createVNode(_component_MDBDropdownMenu, { "aria-labelledby": "dropdownMenuLink" }, {
        default: _withCtx(() => [
          _createVNode(_component_MDBDropdownItem, {
            href: "#",
            onClick: _ctx.english
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MDBIcon, { flag: "uk" }),
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_MDBDropdownItem, {
            href: "#",
            onClick: _ctx.french
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MDBIcon, { flag: "fr" }),
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}